import React from 'react'
import { Variation } from '../../../../types/Article'
import Heading from '../../../../components/Heading'
import Checkbox from '../../../../components/Checkbox'

type VariationPickerProps = {
    selectedValues: number[]
    variation: Variation
    onSelectionChange: (attribute: number, selectedValues: number[]) => void
}
const VariationPicker: React.FC<VariationPickerProps> = ({
    variation,
    onSelectionChange,
    selectedValues,
}) => {
    const toggleValue = (value: number) => {
        if (selectedValues.includes(value)) {
            onSelectionChange(
                variation.kEigenschaft,
                selectedValues.filter((v) => v !== value)
            )
        } else {
            if (selectedValues.length === variation.values.length - 1) {
                onSelectionChange(variation.kEigenschaft, [])
            } else {
                onSelectionChange(variation.kEigenschaft, [
                    ...selectedValues,
                    value,
                ])
            }
        }
    }

    return (
        <div>
            <Heading level={4}>{variation.cName}</Heading>
            <div className={'zr-d-flex zr-flex-column'}>
                <Checkbox
                    property={'all'}
                    value={selectedValues.length === 0}
                    label={'Alle'}
                    onChange={() =>
                        onSelectionChange(variation.kEigenschaft, [])
                    }
                />
                {variation.values.map((value) => (
                    <Checkbox
                        key={value.kEigenschaftWert}
                        property={`${variation.kEigenschaft}`}
                        value={selectedValues.includes(value.kEigenschaftWert)}
                        label={value.cName}
                        onChange={() => toggleValue(value.kEigenschaftWert)}
                    />
                ))}
            </div>
        </div>
    )
}

export default VariationPicker
